import React from "react";
import "./ConfirmModal.css"; // optional if you want to isolate the styles

const ConfirmModal = ({ 
  message = "Are you sure?", 
  onConfirm, 
  onCancel 
}) => {
  return (
    <div className="modal-overlay">
      <div className="custom-modal">
        <p>{message}</p>
        <div className="modal-buttons">
          <button type="button" onClick={onConfirm}>
            Yes
          </button>
          <button type="button" onClick={onCancel}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
